module.exports = __webpack_public_path__ + "static/media/ico_config.6573203f.svg";